import React from 'react';
import HeaderWithBreadcrumbs from './HeaderWithBreadcrumbs';
import { generateComponentDocs, generateStoryDocs } from '../../utils/documentationUtils';

export default {
  title: 'Components/Headers/HeaderWithBreadcrumbs',
  component: HeaderWithBreadcrumbs,
  parameters: {
    layout: 'fullscreen',

    ...generateComponentDocs(
    // What problem does it solve?
      'Provides a breadcrumb and page header component to ensure a consistent, easily adjustable layout across the application.',
      // When & how to use it?
      'Use the HeaderWithBreadcrumbs component at the top of pages.',

      // Related Components
      '\n- **[Breadcrumbs](http://localhost:6006/?path=/docs/components-breadcrumbs--docs)**: Breadcrumbs component.\n\n',
      '\n- **[PagesHeader](http://localhost:6006/?path=/docs/components-headers-pagesheader--docs)**: PagesHeader component.\n\n',
    ),
  },
  tags: ['autodocs'],
};

const Template = (args) => <HeaderWithBreadcrumbs {...args} />;
export const UsersPage = Template.bind({});
export const RoutePage = Template.bind({});

UsersPage.args = {
  name: 'users',
  label: 'Users',
  links: [{ href: '/admin', name: 'Admin' }, { href: '/users', name: 'Users' }],
};

UsersPage.parameters = generateStoryDocs(
// When is this variant used?
  'This variant is used when the header needs to provide navigation to the Users page from the Admin page.',
  // Where is it currently used in the product?
  'It will be used on the Users page to display the breadcrumb path originating from the Admin page.',
);

RoutePage.args = {
  name: 'route',
  label: 'Route',
  size: '',
  links: [{ href: '/sites', name: 'Sites' }, { href: '/route', name: 'Route' }],
};

RoutePage.parameters = generateStoryDocs(
// When is this variant used?
  'This variant is used when the header needs to provide navigation to the Route page from the Sites page.',
  // Where is it currently used in the product?
  'It will be used on the Route page to display the breadcrumb path originating from the Sites page.',
);
